<div class="intro">
  <div class="intro-text container">
    <div></div>
    <div></div>
    <div class="introducing">
      Start staking
      <span class="introducing-color">CGU tokens</span>
    </div>
    <div class="introducing">
      and get ongoing rewards!
    </div>
    <div class="intro-buttons">
      <router-link class="btn stacking-button" :to="'/pools'">
        <span class="btn-content">Start staking</span>
      </router-link>
    </div>
  </div>
  <div class="intro-cgu-coin">
    <img src="/static/images/logo/cgu-logo-dark-blue.svg">
  </div>
</div>
